import React, { useEffect, useState, useCallback, memo } from "react";
import { Link } from 'react-router-dom';
import inMemoryJWT from '../../auth/inMemoryJwt';
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux'
import { getConversationsList, viewConversation } from "../../actions/messagesActions";
import { getProfessionalUsers } from '../../actions/contactsActions'
import { getUsers } from "../../actions/getDataActions";
import circle from '../../img/circulogris.png';
import searchIcon from '../../img/ic__buscador.png'
import diammond from '../../img/diamante.png';
import roomImg from '../../assets/img/rooms.png'
import ImageNameDescription from "../../utils/components/ImageNameDescription/ImageNameDescription";
import localStorage from "../../utils/hooks/useLocalStorage";


const ModalMessages = memo(({ displayModal, isAdmin = false, setIsShowMessages, viewConversation, setNotificationMsg, getUsers, getProfessionalUsers, typeModal = "", usersList, isLoading, professionalList, isLoadingProfessional, isProfessional, getConversationsList, conversationsList, isLoadingConversationsList }) => {
    const history = useHistory()
    const [userActiveChat, setUserActiveChat] = useState({})
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    };

    const [searchName, setSearchName] = useState("")
    const [isViewNotification, setisViewNotification] = useState({})

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }
        inMemoryJWT.waitForTokenRefresh().then(() => {
            getConversationsList(isProfessional, isAdmin)
            history.location.pathname.includes('Professional') ?
                getProfessionalUsers() : getUsers()
        })
    }, [])

  
    const idUser = isProfessional ? localStorage().getItem('professionalID') : localStorage().getItem('idUser')

    if (true) { }
    /*   var users = !isLoadingProfessional && professionalList.filter(
          (item) => item.name &&
              item.name.toUpperCase().includes(searchName.toUpperCase())
      ) || [] */
    else
        var users = !isLoading && usersList.data.filter(
            (item) => item.name &&
                item.name.toUpperCase().includes(searchName.toUpperCase())
        ) || []

    return (
        <div
            className={"modal"}
            style={divStyle}
            onClick={() => setIsShowMessages(false)}>
            <div
                className="modal-content modal-messages-select relative text-black"
                onClick={e => e.stopPropagation()} >
                <div className="column centerItems spaceBetween ml-4 mb-3">
                    <div className="">Mensajes</div>

                </div>
                {/*                 <div className="ml-5">
                    {"pendiente de texto cuando esta vacio y pendiente de diseño"}
                </div> */}
                <div className="modal-messages-msg scroll-menu">

                    {!isLoadingConversationsList && searchName.length ===0 && conversationsList.map(({ addresseeData, conversation }, index) => {
                        let room = conversation.secondRoomId || conversation.secondRoomId
                        let src = null
                        let name = null
                        let lastname = null
                        switch (addresseeData.type) {
                            case "user":
                                src = addresseeData?.picture && addresseeData.picture.url ? addresseeData.picture.url.small : addresseeData.picture
                                name = addresseeData.name
                                lastname = addresseeData.lastname
                                break;
                            case "franchise":
                                src = addresseeData?.picture && addresseeData.picture.url ? addresseeData.picture.url.small : addresseeData.picture
                                name = addresseeData.socialReason
                                break;
                            case "representative":

                                src = addresseeData?.userID && addresseeData?.userID.picture && addresseeData?.userID.picture && addresseeData.userID.picture.url ? addresseeData.userID.picture.url.small : addresseeData.userID.picture
                                name = addresseeData.userID.name
                                lastname = addresseeData.userID.lastname
                                break;
                            case "warehouse":
                                name = addresseeData.name
                                src = addresseeData?.profileId && addresseeData?.profileId.picture && addresseeData?.profileId.picture && addresseeData.profileId.picture.url ? addresseeData.profileId.picture.url.small : addresseeData.profileId.picture
                                break;
                            case "chatroom":
                                name = addresseeData.name
                                src = room?.profilePicture ? (room.profilePicture.url ? room.profilePicture.url.small : room.profilePicture) : roomImg
                                break;
                            case "admin":
                                name = addresseeData.name
                                src = addresseeData.picture &&  addresseeData.picture && addresseeData.picture.files && addresseeData.picture.files.url.origin
                                break;
                        }
                        return <div 
                        key={addresseeData._id}
                        onClick={(e) => {
                            // if (!isViewNotification[user.id])
                            //      viewConversation(conversation._id)
                            //    setisViewNotification(prevState => { return { ...prevState, [user.id]: true } })
                            // user.data.isShowChat = true

                            setIsShowMessages(false)
                            if (room) {
                                history.push("/Rooms/Room/" + room._id)
                            } else {
                                history.push({
                                    pathname: "/Messages",
                                    state: {
                                        dataUser: {
                                            _id: addresseeData._id,
                                            name: name,
                                            lastname: lastname,
                                            picture: src
                                        }

                                    }
                                })
                            }

                            //setUserActiveChat(prevState => { return { ...prevState, [user.data._id]: user.data } })

                        }}>
                            <ImageNameDescription
                                srcImage={src}
                                firstName={name}
                                secondName={lastname}
                                shouldDscriptionEllipsis={false}
                                description={ (conversation.lastMessage.senderID!==localStorage().getItem("idProfile") ? "":"» ") + conversation.lastMessage.content }
                            />
                        </div>
                    })}
                </div>
                <div onClick={(e) => {
                    setIsShowMessages(false)
                    if (isAdmin)
                        history.push("/Admin/Messages")
                    else
                        history.push("/Messages")
                }} className="endContent to-messages pointer">
                    Abrir todos los mensajes
                </div>
            </div>
        </div>
    );
})

const mapStateToProps = (state) => {
    return {
        conversationsList: state.messages.conversationsList,
        isLoadingConversationsList: state.messages.isLoadingConversationsList,
        usersList: state.users.usersList,
        isLoading: state.users.isLoadingUsers,
        professionalList: state.contacts.professionalList,
        isLoadingProfessional: state.contacts.isLoadingProfessionalList
    };
};

export default connect(mapStateToProps, { getConversationsList, getUsers, getProfessionalUsers, viewConversation })(ModalMessages)

{/*  {(!isLoadingProfessional || !isLoading) && searchName.length > 0 && users.map((user, index) => (
                        user._id !== idUser && <div
                            onClick={(e) => {
                                //setIsShowMessages(false)
                                setSearchName("")
                               user.isShowChat = true
                               // setUserActiveChat(prevState => { return { ...prevState, [user._id]: user } })
                                history.push({
                                    pathname: "/Messages",
                                    state: {
                                        dataUser: user
                                    }   
                                })

                            }}
                            className="notification-msg pointer"
                            key={user._id}>
                            {user.profilePicture ? <img alt="img" onError={(e) => e.target.src = circle} className="picture-search-bar m-1" src={user.profilePicture}></img> :
                                <img alt="img" className="picture-search-bar m-1" src={circle}></img>
                            }
                            <div className="row">
                                <div className="">sss{user.name}</div>
                            </div>
                        </div>
                    ))} */}


